import { useRef } from 'react';
import type { JSX } from 'react';

import { Translate } from '@change-corgi/core/react/i18n';
import { Image } from '@change-corgi/design-system-legacy/components/media';
import { Box, Flex } from '@change-corgi/design-system-legacy/layout';
import { Heading } from '@change-corgi/design-system-legacy/typography';

import { CollapsableText } from './CollapsableText';

export function AboutPanel({
	movementObjective,
	movementDetails,
	mediaUrl,
}: {
	movementObjective: string;
	movementDetails: string;
	mediaUrl?: string;
}): JSX.Element {
	const aboutHeadingRef = useRef<HTMLDivElement>(null);

	return (
		<Box>
			<Heading size="h3" as="h3" mb={8}>
				<div ref={aboutHeadingRef}>
					<Translate value="corgi.movement.show.about_heading" />
				</div>
			</Heading>
			<Flex sx={{ flexDirection: ['column', 'row'] }}>
				{mediaUrl && (
					<Box mb={8} sx={{ flex: '40%', order: [undefined, 1] }}>
						<Image src={mediaUrl} alt={movementObjective} data-testid="movement-image" />
					</Box>
				)}
				<Box sx={{ flex: '40%', order: [undefined, 0] }} mr={[0, 16]}>
					<CollapsableText text={movementDetails} anchorRef={aboutHeadingRef} data-testid="movement-details" />
				</Box>
			</Flex>
		</Box>
	);
}
